var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row lg:flex-col justify-center",style:(`--steps: ${_vm.vsteps.length - 1}`)},[_vm._l((_vm.vsteps.length - 1),function(x){return _c('div',{key:x,staticClass:"holder"},[_c('div',{class:`box ${_vm.step >= x ? 'bvisit' : ''} ${
        _vm.$route.name === _vm.vsteps[x - 1].link ? 'bactive' : ''
      }`},[_vm._v(" "+_vm._s(x)+" ")]),_c('div',{class:`line ${_vm.step > x ? 'lactive' : ''}`})])}),_c('div',{class:`box ${
      _vm.$route.name === _vm.vsteps[_vm.vsteps.length - 1].link ? 'bactive' : ''
    }`},[_vm._v(" "+_vm._s(_vm.vsteps.length)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }